<template>
  <div>
    <div class="d-flex flex-column otp">
      <v-otp-input
        :ref="inputRef"
        input-classes="otp-input"
        :separator="separator"
        :num-inputs="nbInputs"
        :should-auto-focus="autoFocus"
        :is-input-num="isNum"
        @on-complete="onComplete"
      />
      <Alert v-if="isError" :title="errorMsg" type="danger" customClass="mt-1" />
    </div>
    <div v-if="showCountdown" style="padding: .5rem 1.125rem .625rem 0;">
      <span>Renvoi possible du code à 6 chiffres dans {{ time | format }}</span>
    </div>
    <Link v-else-if="showSendAgain" :action="onSendAgain" :text="linkText" />
  </div>
</template>

<script>
import OtpInput from "@bachdgvn/vue-otp-input";
import Link from '@/components/Link/Link';
import Alert from '@/components/Alert/Alert';

export default {
	name: "Otp",
  components: {
    OtpInput,
    Link,
    Alert,
  },
  props: {
    inputRef: {
      type: String,
      required: true,
    },
    separator: {
      type: String,
      required: false,
      default: "",
    },
    nbInputs: {
      type: Number,
      required: false,
      default: 6,
    },
    autoFocus: {
      type: Boolean,
      required: false,
      default: true,
    },
    isNum: {
      type: Boolean,
      required: false,
      default: true,
    },
    isError: {
      type: Boolean,
      required: false,
      default: false,
    },
    errorMsg: {
      type: String,
      required: false,
      default: "",
    },
    showCountdown: {
      type: Boolean,
      required: true,
    },
    showSendAgain: {
      type: Boolean,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    linkText: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      time: null,
      interval: null,
    };
  },
  filters: {
    format (value) {
      var minutes = Math.floor(parseInt(value, 10) / 60)
      var seconds = parseInt(value, 10) - minutes * 60
      return `${('0' + minutes).slice(-2)}:${('0' + seconds).slice(-2)}`
    }
  },
  watch: {
    time(n) {
      if (n === -1) {
        this.$emit('onCountDownEnd');
      }
    }
  },
  mounted() {
    this.time = 59;
    this.interval = setInterval(() => {
      this.time -= 1;
    }, 1000);
  },
	methods: {
    onComplete(otp) {
      this.$emit('onComplete', otp);
    },
    onSendAgain() {
      this.$emit('onSendAgain');
      this.time = 59;
    },
    setTime(v) {
      this.time = v;
    }
	},
}
</script>

<style lang="scss">
.otp {
  width: 18.125rem;

  .error, .warning {
    padding: 0rem 0.9375rem;
    background-color: #FDE5E6;

    .error-container, .warning-container {
      display: flex;
      -webkit-box-align: center;
      align-items: center;
      padding: 0rem;

      svg {
        margin: 0rem 0.9375rem 0rem 0rem;
      }

      .error-text, .warning-text {
        flex: 1 1 0rem;
        font-family: o-HelveticaNeue, Arial, sans-serif;
        font-weight: 700;
        font-size: 0.875rem;
        line-height: 1.25rem;
        max-width: 43.75rem;
        color: #000;
        margin: 0rem;
        padding: 0.5rem 0rem 0.625rem;
      }
    }
  }
}

.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.otp-input {
  width: 2.5rem;
  height: 3.215rem;
  padding: 0.375rem;
  margin: 0 0.625rem;
  font-size: 1.25rem;
  border: 3px solid #000;
  text-align: center;

  &:first-child {
    margin-left: 0;
  }

  &.error {
    border: 1px solid red !important;
  }
}
</style>